import { Trans, useTranslation } from '@packlink/translation-provider';
import { Button, ButtonVariant, DialogActions, DialogContent, Typography } from '@shipengine/giger';
import {
    getCancellationActionsStyles,
    getCancellationSuccessDialogStyles,
    getImageStyles,
    getMessageStyles,
    getPriceStyles,
} from './CancelDialogStyles';
import { SubscriptionPrice } from '@Subscriptions/components/SubscriptionPrice/SubscriptionPrice';
import { useAmplitude } from '@hooks';
import { AmplitudeEvents } from '@constants/amplitude';

interface RetentionDiscountProps {
    cancel: () => void;
    applyRetentionDiscount: () => void;
    discountValue?: string;
    discountedPrice?: number;
    pendingApplication?: boolean;
    discountCurrency: string;
}

export function RetentionDiscount({
    cancel,
    applyRetentionDiscount,
    discountValue,
    discountedPrice,
    pendingApplication,
    discountCurrency,
}: RetentionDiscountProps): JSX.Element {
    const { t } = useTranslation();
    const { sendAmplitudeClickEvent } = useAmplitude();
    const {
        cdn: { url: cdnUrl },
    } = config;

    const rejectDiscount = () => {
        sendAmplitudeClickEvent(AmplitudeEvents.SUBSCRIPTION_RETENTION_DISCOUNT_REJECT);
        cancel();
    };

    const applyDiscount = () => {
        sendAmplitudeClickEvent(AmplitudeEvents.SUBSCRIPTION_RETENTION_DISCOUNT_APPLY);
        applyRetentionDiscount();
    };

    return (
        <>
            <DialogContent css={getCancellationSuccessDialogStyles}>
                <img
                    css={getImageStyles}
                    src={`${cdnUrl}/subscriptions/images/discount-gift.png`}
                    alt={t('subscriptions.cancellation-offer.title')}
                    aria-hidden="true"
                    data-id="cancel-img"
                />
                <section>
                    <Typography css={getMessageStyles} variant="body1" component="p">
                        <Trans
                            i18nKey={'subscriptions.cancellation-offer.text'}
                            values={{
                                discountValue: discountValue,
                            }}
                            components={[<strong key="bold" />]}
                        ></Trans>
                    </Typography>
                    <section css={getPriceStyles}>
                        <SubscriptionPrice price={discountedPrice ?? 0} currency={discountCurrency} />
                    </section>
                </section>
            </DialogContent>
            <DialogActions css={getCancellationActionsStyles}>
                <Button variant={ButtonVariant.OUTLINED} onClick={rejectDiscount}>
                    {t('subscriptions.cancellation-offer.decline')}
                </Button>
                <Button onClick={applyDiscount} isLoading={pendingApplication}>
                    {t('subscriptions.cancellation-offer.accept', { discountValue: discountValue })}
                </Button>
            </DialogActions>
        </>
    );
}
